module.exports = __webpack_public_path__ + "img/bus-9.fef991f7.png";